export enum siteTourKeys {
  getPaginatedAllClients = "get-paginated-all-clients",
  getSiteTours = "get-site-tours",
  getCustomTours = "get-custom-tours",
  getACustomTour = "get-a-custom-tour",
  getASiteTour = "get-a-site-tour",
  approvedInspections = "approved-inspections",
  getInspectionDaysPerLocation = "get-inspection-days-per-location",
}
